export default class AcceptInvite {
  constructor ({ id = null, target_id = null, target_type = null, invite_token = null } = {}) {
    this.id = id
    this.target_id = target_id
    this.target_type = target_type
    this.invite_token = invite_token
  }

  get to_mixpanel () {
    return {
      'Id': this.id,
      'Target Id': this.target_id,
      'Target Type': this.target_type
    }
  }

  get to_gtm () {
    return {
      invite_id: this.id,
      target_id: this.target_id,
      target_type: this.target_type
    }
  }
}
